import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=1c38b093"
import script from "./dashboard.js?vue&type=script&lang=js&external"
export * from "./dashboard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports